import { defineComponent as _defineComponent } from 'vue';
import { computed, ref } from "vue";
import Multiselect from "vue-multiselect";
import localize from "@/utils/localization";
export default /*#__PURE__*/ _defineComponent({
    __name: 'ChangeDatatypeTab',
    props: {
        datatypes: null,
        datatypeFromElements: null
    },
    emits: ["clicked-save"],
    setup(__props, { emit }) {
        const props = __props;
        const currentDatatype = ref(props.datatypeFromElements);
        const selectedDatatype = ref(props.datatypes.find((element) => element.id == props.datatypeFromElements));
        const hasSelectedDatatype = computed(() => {
            return Boolean(selectedDatatype.value);
        });
        const enableSave = computed(() => {
            return hasSelectedDatatype.value && selectedDatatype.value.id != currentDatatype.value;
        });
        function clickedSave() {
            emit("clicked-save", selectedDatatype.value);
            currentDatatype.value = selectedDatatype.value.id;
        }
        return { __sfc: true, props, emit, currentDatatype, selectedDatatype, hasSelectedDatatype, enableSave, clickedSave, Multiselect, localize };
    }
});
